/** Max upload size for documents, receipts, signed agreements (must match backend `utils/uploadLimits`). */
export const MAX_DOCUMENT_UPLOAD_BYTES = 25 * 1024 * 1024;
export const MAX_DOCUMENT_UPLOAD_MB = 25;

/**
 * @param {File | null | undefined} file
 * @returns {string | null} Error message, or null if OK / no file
 */
export function getDocumentFileSizeError(file) {
  if (!file || !(file instanceof File)) return null;
  if (file.size > MAX_DOCUMENT_UPLOAD_BYTES) {
    const mb = (file.size / (1024 * 1024)).toFixed(1);
    return `File must be ${MAX_DOCUMENT_UPLOAD_MB} MB or smaller (this file is ${mb} MB).`;
  }
  return null;
}

/** `accept` for interview report file inputs — MIME + extensions (incl. uppercase) so Windows pickers list PDFs reliably. */
export const INTERVIEW_REPORT_ACCEPT =
  'application/pdf,.pdf,.PDF,' +
  'application/msword,.doc,.DOC,' +
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document,.docx,.DOCX,' +
  'image/jpeg,.jpg,.jpeg,.JPG,.JPEG,' +
  'image/png,.png,.PNG';

const INTERVIEW_REPORT_EXT = new Set(['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png']);

/**
 * @param {File | null | undefined} file
 * @returns {string | null} Error message, or null if OK
 */
export function getInterviewReportFileError(file) {
  if (!file || !(file instanceof File)) return null;
  const sizeErr = getDocumentFileSizeError(file);
  if (sizeErr) return sizeErr;
  const name = file.name || '';
  const dot = name.lastIndexOf('.');
  const ext = dot >= 0 ? name.slice(dot).toLowerCase() : '';
  const mime = String(file.type || '').toLowerCase();
  const mimeOk =
    mime === 'application/pdf' ||
    mime === 'application/msword' ||
    mime === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
    mime === 'image/jpeg' ||
    mime === 'image/png';
  // Windows often reports chosen files as octet-stream even when the extension is correct
  const octetOk = mime === 'application/octet-stream' && INTERVIEW_REPORT_EXT.has(ext);
  if (!INTERVIEW_REPORT_EXT.has(ext) && !mimeOk && !octetOk) {
    return 'Choose a PDF, Word document, or image (JPG, PNG).';
  }
  return null;
}
